import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../../../services/axiosComponent";
import { serverData, serviceUrls } from "../../../../services/constant";

export const getLibraryList = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/library/list",
    params: createQueryParams(data),
  });
};

export const addLibrary = async (data) => {
  data.organizationId =
    getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/library",
    data,
  });
};

export const updateLibrary = async (data) => {
  console.log("dta for updateing library", data);
  data.organizationId =
    getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"];

  return await put({
    url: serviceUrls.LIBRARY_SERVICE + "/library",
    data,
  });
};

export const getLibraryInfo = async (entityId) => {
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + `/library?entityId=${entityId}`,
  });
};

// Library Category:
export const getLibraryCategories = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/category/list",
    params: createQueryParams(data),
  });
};

export const updateLibraryCategoryStatus = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  const url = `${serviceUrls.LIBRARY_SERVICE}/category?entityId=${
    data.entityId
  }&status=${data.status}${data.forced ? "&forced=" + data.forced : ""}`;
  return await patch({
    url: url,
  });
};

export const addLibraryCategory = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/category",
    data,
  });
};

export const updateLibraryCategory = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await put({
    url: serviceUrls.LIBRARY_SERVICE + "/category",
    data,
  });
};

export const deleteLibraryCategory = async (entityId) => {
  return await del({
    url: serviceUrls.LIBRARY_SERVICE + `/category?entityId=${entityId}`,
  });
}


export const getLibraryPublications = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/publication/list",
    params: createQueryParams(data),
  });
};

export const updateLibraryPublicationStatus = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  const url = `${serviceUrls.LIBRARY_SERVICE}/publication?entityId=${
    data.entityId
  }&status=${data.status}${data.forced ? "&forced=" + data.forced : ""}`;
  return await patch({
    url: url,
  });
};

export const addLibraryPublication = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/publication",
    data,
  });
};

export const updateLibraryPublication = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await put({
    url: serviceUrls.LIBRARY_SERVICE + "/publication",
    data,
  });
};

export const deleteLibraryPublication = async (entityId) => {
  return await del({
    url: serviceUrls.LIBRARY_SERVICE + `/publication?entityId=${entityId}`,
  });
}


export const getLibraryAuthors = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/author/list",
    params: createQueryParams(data),
  });
};

export const addLibraryAuthor = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/author",
    data,
  });
};

export const updateLibraryAuthorStatus = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  const url = `${serviceUrls.LIBRARY_SERVICE}/author?entityId=${
    data.entityId
  }&status=${data.status}${data.forced ? "&forced=" + data.forced : ""}`;

  return await patch({
    url: url,
  });
};

export const updateLibraryAuthor = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await put({
    url: serviceUrls.LIBRARY_SERVICE + "/author",
    data,
  });
};

export const deleteLibraryAuthor = async (entityId) => {
  return await del({
    url: serviceUrls.LIBRARY_SERVICE + `/author?entityId=${entityId}`,
  });
}


export const getLibraryPanelties = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/penalty/list",
    params: createQueryParams(data),
  });
};

export const addLibraryPanelty = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/penalty",
    data,
  });
};

export const getLibraryBooks = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await get({
    url: serviceUrls.LIBRARY_SERVICE + "/book/list",
    params: createQueryParams(data),
  });
};

export const addLibraryBook = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await post({
    url: serviceUrls.LIBRARY_SERVICE + "/book",
    data,
  });
};

export const updateLibraryBook = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  return await put({
    url: serviceUrls.LIBRARY_SERVICE + "/book",
    data,
  });
};

export const updateLibraryBookStatus = async (data) => {
  data.siteId = getLocalStorageData("profileDetails")["_SITE"];
  data.regionId = getLocalStorageData("profileDetails")["_REGION"];
  const url = `${serviceUrls.LIBRARY_SERVICE}/book?entityId=${
    data.entityId
  }&status=${data.status}${data.forced ? "&forced=" + data.forced : ""}`;

  return await patch({
    url: url,
  });
}

export const deleteLibraryBook = async (entityId) => {
  return await del({
    url: serviceUrls.LIBRARY_SERVICE + `/book?entityId=${entityId}`,
  });
}